import axios from 'axios';
import qs from 'qs';
import urlConfig from '@/config';
import HllUI from '@/libs/hll-m-ui';
import { UNIQUE_ID } from '@/components/js/watchDog/uniqueId';
import { getAccessTokenByToken } from '@/components/mixins/tokenIn';
import {
  callApp,
  getUrlParam,
  parseUserType,
  isJdMiniProgram,
  isCompanyApp,
  parseBusinessLine,
  isXlAppByClientType,
  isXlMiniProgram
} from '@/utils';
import { LOGIN_HOST } from '@/utils/constants';

const uuidv1 = require('uuid/v1');
import {
  type,
  // getFingerPrint,
  // getTDPrint,
  isHllApp,
  getAccessToken,
  isWxMiniProgram,
  isAlipayMiniUa,
  isBaiduBoxUa
} from '@/utils';
import { XL_ACCOUNT_TYPE } from '@/utils/constants';
// import Router from '@/router' //使用vue-router

const reloadByTokenInStatus = status => {
  let reloaded = sessionStorage.getItem('reloaded'); //防止重复刷新
  if (!reloaded && status) {
    sessionStorage.setItem('reloaded', 1);
    location.reload();
  }
};

const LOGIN_URLS = [
  '/act/passport/verify_type',
  '/act/passport/geetest',
  '/act/passport/send_sms_code',
  '/act/passport/graph',
  '/act/passport/phone_in',
  '/act/passport/token_in'
];

const matchJavaApiAboutLogin = (list, url) =>
  url && Array.isArray(list) && list.some(x => x.indexOf(url) !== -1);

// 只对`登录态`相关的api做 java 要求的配置
function mapBaseUrlHost(accountType, url) {
  if (
    accountType === XL_ACCOUNT_TYPE &&
    matchJavaApiAboutLogin(LOGIN_URLS, url)
  ) {
    // 小拉账号体系
    return urlConfig.secondBaseUrl;
  }
  return urlConfig.baseURL;
}

function createInstance(axios, router, store) {
  //创建axios实例
  //请求头动态配置
  const instance = axios.create({
    baseURL: urlConfig.baseURL,
    timeout: 10000, // 超时
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    transformRequest: [
      function(data) {
        return qs.stringify(data);
      }
    ]
  });

  // 添加请求拦截器
  instance.interceptors.request.use(
    async function(config) {
      const { hostInfo, accountType } = store.state.global || {};
      config.baseURL = mapBaseUrlHost(accountType, config.url);
      // for test. order is very important.
      if (hostInfo && hostInfo[LOGIN_HOST]) {
        config.baseURL = hostInfo[LOGIN_HOST];
      }
      // just for java api.
      if (accountType === XL_ACCOUNT_TYPE) {
        config.headers['X-User-BusinessLine'] = parseBusinessLine(accountType);
        config.headers['X-Unique-Id'] = UNIQUE_ID;
      }

      // 发送请求之前
      // console.log(router)
      // 显示 loading
      !config.hidden &&
        HllUI.$hll.showLoading({
          cover: 2,
          delay: 1000
        });
      // let td = await getTDPrint();
      // try {
      //   fp = await getFingerPrint();
      // } catch (err) {
      //   console.log(err);
      // }
      if (config.method == 'get') {
        //添加浏览器指纹
        config.params || (config.params = {}); //如果没有参数则默认构造空对象
        // config.params.device_sign = td;
        addDefaultParams(config.params, store, { accountType });
      } else if (config.method == 'post') {
        config.data || (config.data = {}); //如果没有参数则默认构造空对象
        // config.data.device_sign = td;
        addDefaultParams(config.data, store, { accountType });
      }
      // PHP API Headers 安全相关改造
      // 增加：Authorization、X-User-Type
      config.headers.common['Authorization'] = getAccessToken({ accountType });
      config.headers.common['X-User-Type'] = parseUserType(
        store.state.global.env
      );
      return config;
    },
    function(error) {
      // 对请求错误做些什么
      return Promise.reject(error);
    }
  );

  // 添加响应拦截器
  instance.interceptors.response.use(
    async function(response) {
      // 对响应数据做点什么
      HllUI.$hll.hideLoading(); // 清除loading
      let res = response.data;
      // return response
      if (type(res) != 'object') {
        HllUI.$hll.toast('网络错误');
        return res;
      }
      if ('ret' in res) {
        console.log(res, 'ret=====>index.js', isHllApp());

        //对内部请求做判断处理
        if (res.ret == 0) {
          return res.data;
        } else if (/40[45]/.test(res.ret)) {
          //404 405 状态
          // HllUI.$hll.toast(res.msg);
          if (isXlMiniProgram()) {
            // 小拉 微信小程序
            let globalState = (store.state || {}).global || {};
            let loginStatus = await getAccessTokenByToken(
              globalState.appToken,
              globalState.env,
              { accountType: globalState.accountType }
            ); //重新调用tokenIn接口,返回tokenIn状态
            reloadByTokenInStatus(loginStatus); //根据tokenIN状态进行重新加载
            // 如果 reload 了页面，下面 js 也不会执行
            return wx.miniProgram.reLaunch({
              url: `/pages/index/index?webview=${encodeURIComponent(
                location.href
              )}`
            });
          } else if (isWxMiniProgram()) {
            wx.miniProgram.navigateTo({
              url: '/pages/login/index'
            });
          } else {
            if (isHllApp()) {
              //App内
              let loginStatus = await getAccessTokenByToken(
                store.state.global.appToken,
                store.state.global.env,
                { accountType: store.state.global.accountType }
              ); //重新调用tokenIn接口,返回tokenIn状态
              reloadByTokenInStatus(loginStatus); //根据tokenIN状态进行重新加载
              if (isXlAppByClientType()) {
                // 小拉APP的流程
                // 小拉 app
                return my.reLaunch({
                  url: `/pages/index/index?webview=${encodeURIComponent(
                    location.href
                  )}`
                });
              } else {
                let args = isCompanyApp()
                  ? {
                      action: 'openNativePage',
                      type: 1
                    }
                  : {
                      action: 'login'
                    };
                callApp(JSON.stringify(args));
              }
            } else if (isJdMiniProgram()) {
              /* eslint-disable  */
              // 京东小程序
              return jd.miniProgram.navigateTo({
                url: '/pages/login/index'
              });
            } else if (isAlipayMiniUa()) {
              my.navigateTo({
                url: '/pages/login/index'
              });
            } else if (isBaiduBoxUa()) {
              console.log('axios: swan is', typeof swan, swan);
              swan.webView.navigateTo({
                url: '/pages/login/index'
              });
            } else {
              router.options.routes.some(e => e.path == '/login') &&
                router.replace('/login'); //路由中存在login时跳转至login
            }
          }
        } else {
          HllUI.$hll.toast(res.msg);
        }
      } else {
        //外部接口
        return res;
      }
      return Promise.reject(res);
    },
    function (error) {
      // 对响应错误做点什么
      HllUI.$hll.hideLoading(); // 清除loading
      return Promise.reject(error);
    }
  );
  return instance;
}

function addDefaultParams(data, store, cfg = {}) {
  let token = getUrlParam('token') || getUrlParam('_token');
  if (type(data) != 'object') {
    return data;
  }
  if (!('access_token' in data) && token !== '') {
    // multiple account systerm
    data.access_token = getAccessToken(cfg);
  }
  if (!('ref' in data) && (getUrlParam('ref') || getUrlParam('_ref'))) {
    data.ref = getUrlParam('ref') || getUrlParam('_ref');
  }
  if (!('uuid' in data)) {
    data.uuid = store.state.global.uuid;
  }
  if (!('fingerprint' in data)) {
    if (isHllApp()) {
      let res = localStorage.getItem('uuid');
      if (!res) {
        res = uuidv1()
          .replace(/-/g, '')
          .slice(0, 32);
        localStorage.setItem('uuid', res);
      }
      // data.fingerprint = res;
    } else {
      // data.fingerprint = fp;
    }
  }
}

//初始化
function install(Vue, router, store) {
  let instance = createInstance(axios, router, store);
  //添加全局方法
  Vue.prototype.$axios = instance;
}

export default {
  install
};
